var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_23_1833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4684 13.2746H5.92188C5.31758 13.2746 4.82812 12.7852 4.82812 12.1809C4.82812 11.5766 5.31758 11.0871 5.92188 11.0871H16.4684C17.0727 11.0871 17.5621 11.5766 17.5621 12.1809C17.5621 12.7852 17.0727 13.2746 16.4684 13.2746Z",
    fill: "var(--menu-icon-accent, #8fb4ff)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.4684 17.6496H5.92188C5.31758 17.6496 4.82812 17.1602 4.82812 16.5559C4.82812 15.9516 5.31758 15.4621 5.92188 15.4621H16.4684C17.0727 15.4621 17.5621 15.9516 17.5621 16.5559C17.5621 17.1602 17.0727 17.6496 16.4684 17.6496Z",
    fill: "var(--menu-icon-accent, #8fb4ff)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.4684 22.0246H5.92188C5.31758 22.0246 4.82812 21.5352 4.82812 20.9309C4.82812 20.3266 5.31758 19.8371 5.92188 19.8371H16.4684C17.0727 19.8371 17.5621 20.3266 17.5621 20.9309C17.5621 21.5352 17.0727 22.0246 16.4684 22.0246Z",
    fill: "var(--menu-icon-accent, #8fb4ff)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6562 2.77463H15.1869C14.7352 1.5015 13.5195 0.587128 12.0938 0.587128H9.90625C8.48055 0.587128 7.26484 1.5015 6.81313 2.77463H3.34375C1.53469 2.77463 0.0625 4.24682 0.0625 6.05588V25.3059C0.0625 27.1149 1.53469 28.5871 3.34375 28.5871H18.6562C20.4653 28.5871 21.9375 27.1149 21.9375 25.3059V6.05588C21.9375 4.24682 20.4653 2.77463 18.6562 2.77463ZM9.90625 2.77463H12.0938C12.697 2.77463 13.1875 3.26517 13.1875 3.86838C13.1875 4.47158 12.697 4.96213 12.0938 4.96213H9.90625C9.30305 4.96213 8.8125 4.47158 8.8125 3.86838C8.8125 3.26517 9.30305 2.77463 9.90625 2.77463ZM19.75 25.3059C19.75 25.9091 19.2595 26.3996 18.6562 26.3996H3.34375C2.74055 26.3996 2.25 25.9091 2.25 25.3059V6.05588C2.25 5.45267 2.74055 4.96213 3.34375 4.96213H6.81313C7.26484 6.23525 8.48055 7.14963 9.90625 7.14963H12.0938C13.5195 7.14963 14.7352 6.23525 15.1869 4.96213H18.6562C19.2595 4.96213 19.75 5.45267 19.75 6.05588V25.3059Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.875,
    height: 28,
    fill: "white",
    transform: "translate(0.0625 0.587128)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.d145cca0614b6493d48dc3c35e0dad9f.svg";
export { ForwardRef as ReactComponent };